import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';

@Component({
  templateUrl: './update-serial-number-dialog.component.html'
})
export class UpdateSerialNumberDialogComponent implements OnInit {
  public serialNumber: number;
  public acceptColor: string;

  constructor(private matDialogRef: MatDialogRef<UpdateSerialNumberDialogComponent>) {
  }

  public ngOnInit(): void {
    this.acceptColor = 'green';
    this.matDialogRef.updateSize('300px', '200px');
  }

  closeDialog() {
    this.matDialogRef.close();
  }

  confirm() {
    this.matDialogRef.close(this.serialNumber);
  }

  cancel() {
    this.matDialogRef.close();
  }
}
